import { render, staticRenderFns } from "./Aimguud.vue?vue&type=template&id=2e478dd3&"
import script from "./Aimguud.vue?vue&type=script&lang=js&"
export * from "./Aimguud.vue?vue&type=script&lang=js&"
import style0 from "./Aimguud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VImg,VMain})
